import { atom } from 'jotai';

export const unsavedChangesCallbackState = atom<((discardChanges: boolean) => void | Promise<void>) | null>(null);
